// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5w-1";
export var standaloneTable = "_5w-0";